import React from "react";

const PODetails = (props) => {
    const brand = props.watch.brand;
    const model = props.watch.model;
    const year = props.watch.year;
    const size = props.watch.size;
    const refNum = props.watch.refNum;
    const serialNum = props.watch.serialNum;
    const condition = props.watch.condition;
    const box = props.watch.box;
    const papers = props.watch.papers;
    const purDate = props.watch.purOrder.purDate;
    const supplier = props.watch.purOrder.supplier;
    const purStatus = props.watch.purOrder.purStatus;
    const purPrice = props.watch.purOrder.purPrice;
    const purNotes = props.watch.purOrder.purNotes;
    const customer = props.watch.request ? props.watch.request.customer : '';

    return (
        <div className="details-modal-container">
            <div className="details-container">
                <div className="inner-form-container">
                    <label>Brand</label>
                    <p>{brand}</p>
                </div>
                <div className="inner-form-container">
                    <label>Model</label>
                    <p>{model}</p>
                </div>
                <div className="inner-form-container">
                    <label>Year</label>
                    <p>{year}</p>
                </div>
                <div className="inner-form-container">
                    <label>Size</label>
                    <p>{size}</p>
                </div>
                <div className="inner-form-container">
                    <label>Reference Number</label>
                    <p>{refNum}</p>
                </div>
                <div className="inner-form-container">
                    <label>Serial Number</label>
                    <p>{serialNum}</p>
                </div>
                <div className="inner-form-container">
                    <label>Condition</label>
                    <p>{condition}</p>
                </div>
                <div className="inner-form-container">
                    <label>Box</label>
                    <p>{box === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Papers</label>
                    <p>{papers === true ? "Yes" : "No"}</p>
                </div>
            </div>

            <div className="details-container">
                <div className="inner-form-container">
                    <label>Purchase Date</label>
                    <p>{purDate.slice(0,10)}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Price</label>
                    <p>${purPrice}</p>
                </div>
                <div className="inner-form-container">
                    <label>Supplier</label>
                    <p>{supplier}</p>
                </div>
                <div className="inner-form-container">
                    <label>Customer</label>
                    <p>{customer}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Status</label>
                    <p>{purStatus}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Notes</label>
                    <p>{purNotes}</p>
                </div>
            </div>
        </div>
    )
}

export default PODetails;